import {
	WeaTools
} from 'ecCom'

export const getKQReport = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportInfo', 'POST', params);
}

export const getKQCarendarReport = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQMonthReportInfo', 'POST', params);
}

export const getHrmKQSignInfo = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQSignInfo', 'POST', params);
}


export const getTableData = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo', 'POST', params);
}

export const getHrmNewWorkflwList = params => {
	return WeaTools.callApi('/api/hrm/kq/report/getHrmNewWorkflwList', 'GET', params);
}

export const getHrmKQReportDetialInfo = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo', 'POST', params);
}

export const getTab = params => {
	return WeaTools.callApi('/api/kq/report/detail/getTabs', 'POST', params);
}

export const getKQReportDetail = params => {
	return WeaTools.callApi('/api/kq/report/detail/getKQReportDetail', 'POST', params);
}

export const getwfinfo = params => {
	return WeaTools.callApi('/api/workflow/createreq/wfinfo', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/apis/checking.js